import React, { useEffect, useState } from 'react'
import ProfileImage from "../Data/Abhinav.jpg"

export const About = () => {
  const [experience, setExperience] = useState('');

  useEffect(() => {
    document.title = 'Abhinav - About';

    const startDate = new Date('2023-06-20');
    const now = new Date();

    // Calculate the year and month differences
    let totalMonths =
      (now.getFullYear() - startDate.getFullYear()) * 12 +
      (now.getMonth() - startDate.getMonth());

    // Adjust for partial month if current day is less than the start day
    if (now.getDate() < startDate.getDate()) {
      totalMonths -= 1;
    }

    // Convert months to years as a decimal and round to 1 decimal place
    const yearsDecimal = (totalMonths / 12).toFixed(0); // Rounds to 1 decimal place
    setExperience(yearsDecimal + "." + totalMonths % 12);
  }, []);

  return (
    <div className='container'>
      <div className="section-mid">
        <div className="fx fx-far">
          <p class="w-100 paragraph">
            Hi! I’m <strong>Abhinav</strong> — a passionate <strong>Unity Developer</strong> with 3+ years of experience building scalable, optimized, and visually engaging games across mobile and desktop platforms. Currently working at <strong>Gametion Technologies Pvt. Ltd.</strong>, I specialize in gameplay programming, UI systems, performance optimization, live game support, and cross-platform development using Unity and C#.
            <br /><br />
            I enjoy building robust gameplay systems, optimizing performance, and refining the small details that make games feel polished and responsive. My work often involves improving legacy codebases, debugging complex gameplay issues, integrating animation workflows, and managing dynamic content pipelines using Unity Addressables and AssetBundles.
          </p>

          {/* <div className='w-20 img-frame-profile h-100 fx fx-center'>
            <img src={ProfileImage} alt="" className='img' />
          </div> */}
        </div>

        <h2 className='about-heading'>Skills</h2>
        <ul class="skills-list ft-s-normal-2">
          <li><strong>Programming Languages:</strong> C, C++, C#, Python(Basics), Node.JS</li>
          <li><strong>Performance & Architecture: </strong>  Data-Oriented Architecture, Profiling & Optimization, CI/CD (Jenkins), Memory Management, OOP & Design Patterns, Editor Scripting.</li>
          <li><strong>Unity & Gameplay Systems:</strong> Unity 2D UI, 2D Physics, Animation (Animator Controller & Spine), DOTween, Particle Systems, Input Systems, Addressables & AssetBundles, Cross-platform & Multi-resolution Support, Multiplayer & Networking Basics.</li>
          <li><strong>Programming & Design Patterns:</strong> Strong OOP skills; implemented Singleton, Observer, Command, Entity-Component-System (ECS), Factory, and State patterns for maintainable and optimized Unity gameplay.</li>
          <li><strong>Version Control:</strong> Git, GitHub, BitBucket, SVN</li>
        </ul>

        <h2 className='about-heading'>Experiences</h2>
          <p class="paragraph"><strong>Gametion Technologies Pvt. Ltd.</strong> — <em>Feb 2026 - Present</em></p>
          <ul class="platforms-list ft-s-normal-2">

            <li><strong>Gameplay Systems & UI Development:</strong> Developed and integrated gameplay systems for a live mobile gaming platform using Unity and C#, including gameplay mechanics, move validation logic, UI systems, and gameplay state management.</li>

            <li><strong>Data Handling & Server Sync:</strong> Implemented JSON-based gameplay save/load systems and synchronized gameplay data with backend server flows for persistent player progression.</li>

            <li><strong>Optimization & Debugging:</strong> Performed gameplay optimization, profiling, memory analysis, and bug fixing to improve gameplay stability, responsiveness, and overall user experience in live production environments.</li>

            <li><strong>Live Game Support & Feature Integration:</strong> Integrated advertisement systems, resolved production issues, and collaborated with team members on feature improvements and gameplay refinements.</li>

          </ul>

          <p class="paragraph"><strong>Vihaa Technologies LLP</strong> — <em>June 2023 - Feb 2026</em></p>
          <ul class="platforms-list ft-s-normal-2">

            <li><strong>Gameplay & UI Enhancements:</strong> Integrated 20+ new gameplay modes and redesigned UIs for multiple games, collaborating closely with team members to enhance engagement and retention.</li>

            <li><strong>Cross-Platform Game Development:</strong> Implemented, tested, and deployed 15+ games across Android, Amazon, Windows, macOS, and iOS, including fixing live game bugs and ensuring platform compliance.</li>

            <li><strong>Dynamic Asset & Data Management:</strong> Engineered runtime asset loading with AssetBundles (AWS, Play Asset Delivery, On-Demand Resources iOS) and integrated Unity Addressables; managed XML/JSON/CSV data.</li>

            <li><strong>Performance Optimization & Code Refactoring:</strong> Optimized codebases using profiling, debugging, memory management, and clean architecture practices to improve gameplay and rendering performance.</li>

            <li><strong>Cross-Device & Pipeline Support:</strong> Optimized games for foldables, widescreens, split-screen, and multi-window devices while maintaining CI/CD pipelines via Jenkins for smooth multi-platform deployment.</li>

          </ul>

        <h2 className='about-heading'>Education</h2>
        <p class="paragraph"><strong>Bachelor of Technology in Information Technology</strong>
          <br>
          </br>
          Rajkiya Engineering College, Banda, Uttar Pradesh, India — <em>2019 - 2023</em>
        </p>

        <h2 className='about-heading'>Interests</h2>
        <p class="paragraph">Game Development, AI in Games, Virtual Reality (VR), Space Science, Physics, Mathematics, Music, Cricket, and Football.</p>
      </div>
    </div >
  )
}
